import { useRef, useState } from "react";
import { FormatDateToDDMMYY } from "../../utils/FormatDate"
import HandleUpdateText from "../../utils/HandleUpdateText"
import HandleUpdateSelect from "../../utils/HandleUpdateSelect";
import { Button, Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from "@mui/material";
import HandleUpdateMultiselector from "../../utils/liveUpdaterHandlers/HandleUpdateMultiselector";
import HandleUpdateCheckbox from "../../utils/HandleUpdateCheckbox";
import { FaEye, FaFacebook, FaLink, FaLinkedin, FaPlus, FaTiktok, FaTrash, FaYoutube } from "react-icons/fa";
import Modal from "../ui/Modal";
import VerifyValidUrl from "../../utils/VerifyValidUrl";
import { toast } from "react-toastify";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import CopyToClipBoard from "../../utils/CopyToClipBoard";
import NoDataScreen from "../ui/temp-screens/NoDataScreen";
import AddIcon from "@mui/icons-material/Add";
import { HandleUpdateItem } from "../../utils/basicCrud/HandleUpdateItem";
import { ItemBoxNotEditable } from "./ItemBoxNotEditable";
import { GetStatusColor, PlanBackgroundColor } from "../../utils/GetTextColor";
import { LinkViewer } from "./LinkViewer";


const ItemRowVentasAudiovisuales = ({s, setServices, workers, user, colorAudiovisual}) => {

  // Plataformas

  // Youtube
  const [videoYoutubeMakingOf, setVideoYoutubeMakingOf] = useState(s.videoYoutubeMakingOf ? s.videoYoutubeMakingOf : "")
  const [videoYoutubeTestimonio, setVideoYoutubeTestimonio] = useState(s.videoYoutubeTestimonio ? s.videoYoutubeTestimonio : "")
  const [videoYoutubeProyecto, setVideoYoutubeProyecto] = useState(s.videoYoutubeProyecto ? s.videoYoutubeProyecto : "")

  // Facebook
  const [videoFacebookMakingOf, setVideoFacebookMakingOf] = useState(s.videoFacebookMakingOf ? s.videoFacebookMakingOf : "")
  const [videoFacebookTestimonio, setVideoFacebookTestimonio] = useState(s.videoFacebookTestimonio ? s.videoFacebookTestimonio : "")
  const [videoFacebookProyecto, setVideoFacebookProyecto] = useState(s.videoFacebookProyecto ? s.videoFacebookProyecto : "")

  // Linkedin
  const [videoLinkedinMakingOf, setVideoLinkedingMakingOf] = useState(s.videoLinkedinMakingOf ? s.videoLinkedinMakingOf : "")
  const [videoLinkedinTestimonio, setVideoLinkedinTestimonio] = useState(s.videoLinkedinTestimonio ? s.videoLinkedinTestimonio : "")
  const [videoLinkedinProyecto, setVideoLinkedinProyecto] = useState(s.videoLinkedinProyecto ? s.videoLinkedinProyecto : "")

  // Tiktok
  const [videoTikTokMakingOf, setVideoTikTokMakingOf] = useState(s.videoTikTokMakingOf ? s.videoTikTokMakingOf : "")
  const [videoTikTokTestimonio, setVideoTikTokTestimonio] = useState(s.videoTikTokTestimonio ? s.videoTikTokTestimonio : "")
  const [videoTikTokProyecto, setVideoTikTokProyecto] = useState(s.videoTikTokProyecto ? s.videoTikTokProyecto : "")

  // Estados de modales
  const [modalProyectoBorrador, setModalProyectoBorrador] = useState(false)
  const [modalMakingOf, setModalMakingOf] = useState(false)
  const [modalTestominioEditado, setModalTestimonioEditado] = useState(false)
  const [modalProyectoEditado, setModalProyectoEditado] = useState(false)
  const [modalMakingOfEditado, setModalMakingOfEditado] = useState(false)
  const [modalPlataformas, setModalPlataformas] = useState(false)

  // Links de modales
  const [linksTestimonioEditado, setLinksTestimonioEditado] = useState(s.testimonioClienteVideoEditado ? s.testimonioClienteVideoEditado : [])
  const [linksProyectoEditado, setLinksProyectoEditado] = useState(s.grabacionProyectoEditado ? s.grabacionProyectoEditado : [])
  const [linksMakingOfEditado, setLinksMakingOfEditado] = useState(s.grabacionProyectoMakingOfEditado ? s.grabacionProyectoMakingOfEditado : [])


  const handleSave = async () => {
    try {
      const videoLinks = { 
        videoYoutubeMakingOf, videoYoutubeTestimonio, videoYoutubeProyecto,
        videoFacebookMakingOf, videoFacebookTestimonio, videoFacebookProyecto,
        videoLinkedinMakingOf,  videoLinkedinTestimonio, videoLinkedinProyecto,
        videoTikTokMakingOf, videoTikTokTestimonio, videoTikTokProyecto
      };
  
      // Filtrar solo las URLs que tienen texto para validar
      const invalidUrls = Object.entries(videoLinks).filter(
        ([, url]) => url.trim() !== "" && !VerifyValidUrl(url) // Solo evaluar si hay texto
      );
  
      if (invalidUrls.length > 0) {
        toast.warning("Los enlaces deben ser URL válidas y comenzar con https://");
        return; // No guardar nada si hay URLs inválidas
      }
  
      // Enviar todas las URLs al backend, incluyendo las vacías
      const response = await axios.put(`${BACKEND}/api/serviciosCotizaciones/${s.id}`, videoLinks);
      console.log(response)
  
      setModalPlataformas(false);
      toast.success("Links guardados con éxito");
    } catch (e) {
      console.error("Error al guardar los links:", e);
      toast.error("Error al guardar los links, intenta de nuevo.");
    }
  };

  const addLink = (stateSetter) => {
    stateSetter((prev) => [...prev, { link: "" }]);
  };
  
  const updateLink = (stateSetter, index, newValue) => {
    stateSetter((prev) =>
      prev.map((l, i) => (i === index ? { ...l, link: newValue } : l))
    );
  };
  
  const deleteLink = (stateSetter, index) => {
    stateSetter((prev) => prev.filter((_, i) => i !== index));
  };
  
  return (
    <tr>
      {/* A subir por el especialista */}
      {/* Proyecto borrador */}
      <Modal
        activeModal={modalProyectoBorrador}
        onClose={() => setModalProyectoBorrador(false)}
        centered
        title="Links de las grabaciones (borrador) por el especialista"
      >
        <div className="max-h-[75vh] overflow-y-auto">
          <div className="flex flex-col gap-2 items-center justify-center w-full">
            {!Array.isArray(s.grabacionProyectoBorrador) || s.grabacionProyectoBorrador.length === 0 ? (
              <div className="h-[150px] w-full">
                <NoDataScreen border text="No hay links registrados"/>
              </div>
            ) : (
              <div className="flex flex-col gap-2 w-full">
                {s.grabacionProyectoBorrador.map((s) => (
                  <LinkViewer icon={FaLink} value={s.link} />
                ))}
              </div>
            )}
          </div>
        </div>
      </Modal>
      {/* Making Of borrador */}
      <Modal
        activeModal={modalMakingOf}
        onClose={() => setModalMakingOf(false)}
        centered
        title="Links de las grabaciones (making of) por el especialista"
      >
        <div className="max-h-[75vh] overflow-y-auto">
          <div className="flex flex-col gap-2 items-center justify-center w-full">
            {!Array.isArray(s.grabacionProyectoMakingOf) || s.grabacionProyectoMakingOf.length === 0 ? (
              <div className="h-[150px] w-full">
                <NoDataScreen border text="No hay links registrados"/>
              </div>
            ) : (
              <div className="flex flex-col gap-2 w-full">
                {s.grabacionProyectoMakingOf.map((s) => (
                  <LinkViewer icon={FaLink} value={s.link} />
                ))}
              </div>
            )}
          </div>
        </div>
      </Modal>

      {/* A editar por el productor */}
      {/* Testimonio cliente editado */}
      <Modal
        activeModal={modalTestominioEditado}
        onClose={() => setModalTestimonioEditado(false)}
        centered
        title="Links de las grabaciones del testominio del cliente (editado)"
      >
        <div className="max-h-[75vh] overflow-y-auto">
          {linksTestimonioEditado.length === 0 ? (
            <div className="h-[150px]">
              <NoDataScreen border/>
            </div>
          ) : (
            linksTestimonioEditado.map((l, i) => (
              <div className="mb-4 mt-4" key={i}>
                <label className="text-xs block text-gray-700 mb-2">
                  Link {i + 1}
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
                    <FaLink />
                  </span>
                  <input
                    type="text"
                    placeholder="Introduce un link"
                    value={l.link}
                    onChange={(e) => updateLink(setLinksTestimonioEditado, i, e.target.value)}
                    className="text-xs bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5"
                  />
                  <button 
                    className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-s-0 border-gray-300 border-s-0 rounded-e-md"
                    onClick={() => deleteLink(setLinksTestimonioEditado, i)}
                  >
                    <FaTrash />
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        <Button
          variant="contained"
          endIcon={<AddIcon />}
          sx={{
            fontWeight: "bold",
            fontFamily: "poppins",
            paddingBlock: "4px",
            backgroundColor: "#a5cef5",
            marginTop: "20px",
            textTransform: "none",
            borderRadius: "8px",
            width: "100%",
            "&:hover": { backgroundColor: "#1d80e0" },
          }}
          onClick={() => addLink(setLinksTestimonioEditado)}
        >
          Nuevo Link
        </Button>

        <Button
          variant="contained"
          sx={{
            fontWeight: "bold",
            fontFamily: "poppins",
            paddingBlock: "4px",
            backgroundColor: "#ff6400",
            marginTop: "20px",
            textTransform: "none",
            borderRadius: "8px",
            width: "100%",
            "&:hover": { backgroundColor: "#bb4a03" },
          }}
          onClick={() => {HandleUpdateItem({
            route: "serviciosCotizaciones",
            id: s.id,
            field: "testimonioClienteVideoEditado",
            value: linksTestimonioEditado
          })
          setModalTestimonioEditado(false)
        }}
        >
          Guardar
        </Button>
      </Modal>
      
      {/* Proyecto editado */}
      <Modal
        activeModal={modalProyectoEditado}
        onClose={() => setModalProyectoEditado(false)}
        centered
        title="Links de las grabaciones (editado) por el productor responsable"
      >
        <div className="max-h-[75vh] overflow-y-auto">
          {linksProyectoEditado.length === 0 ? (
            <div className="h-[150px]">
              <NoDataScreen border/>
            </div>
          ) : (
            linksProyectoEditado?.map((l, i) => (
              <div className="mb-4 mt-4" key={i}>
                <label className="text-xs block text-gray-700 mb-2">
                  Link {i + 1}
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
                    <FaLink />
                  </span>
                  <input
                    type="text"
                    placeholder="Introduce un link"
                    value={l.link}
                    onChange={(e) => updateLink(setLinksProyectoEditado, i, e.target.value)}
                    className="text-xs bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5"
                  />
                  <button 
                    className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-s-0 border-gray-300 border-s-0 rounded-e-md"
                    onClick={() => deleteLink(setLinksProyectoEditado, i)}
                  >
                    <FaTrash />
                  </button>
                </div>
              </div>
            ))
          )}

          <Button
            variant="contained"
            endIcon={<AddIcon />}
            sx={{
              fontWeight: "bold",
              fontFamily: "poppins",
              paddingBlock: "4px",
              backgroundColor: "#a5cef5",
              marginTop: "20px",
              textTransform: "none",
              borderRadius: "8px",
              width: "100%",
              "&:hover": { backgroundColor: "#1d80e0" },
            }}
            onClick={() => addLink(setLinksProyectoEditado)}
          >
            Nuevo Link
          </Button>

          <Button
            variant="contained"
            sx={{
              fontWeight: "bold",
              fontFamily: "poppins",
              paddingBlock: "4px",
              backgroundColor: "#ff6400",
              marginTop: "20px",
              textTransform: "none",
              borderRadius: "8px",
              width: "100%",
              "&:hover": { backgroundColor: "#bb4a03" },
            }}
            onClick={() => {HandleUpdateItem({
              route: "serviciosCotizaciones",
              id: s.id,
              field: "grabacionProyectoEditado",
              value: linksProyectoEditado
            })
            setModalProyectoEditado(false)
          }}
          >
            Guardar
          </Button>
        </div>
      </Modal>

      {/* Making Of editado */ }
      <Modal
        activeModal={modalMakingOfEditado}
        onClose={() => setModalMakingOfEditado(false)}
        centered
        title="Links de las grabaciones (making of) por el especialista"
      >
        <div className="max-h-[75vh] overflow-y-auto">
          {linksMakingOfEditado.length === 0 ? (
            <div className="h-[150px]">
              <NoDataScreen border/>
            </div>
          ) : (
            linksMakingOfEditado.map((l, i) => (
              <div className="mb-4 mt-4" key={i}>
                <label className="text-xs block text-gray-700 mb-2">
                  Link {i + 1}
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
                    <FaLink />
                  </span>
                  <input
                    type="text"
                    placeholder="Introduce un link"
                    value={l.link}
                    onChange={(e) => updateLink(setLinksMakingOfEditado, i, e.target.value)}
                    className="text-xs bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5"
                  />
                  <button 
                    className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-s-0 border-gray-300 border-s-0 rounded-e-md"
                    onClick={() => deleteLink(setLinksMakingOfEditado, i)}
                  >
                    <FaTrash />
                  </button>
                </div>
              </div>
            ))
          )}
          <Button
            variant="contained"
            endIcon={<AddIcon />}
            sx={{
              fontWeight: "bold",
              fontFamily: "poppins",
              paddingBlock: "4px",
              backgroundColor: "#a5cef5",
              marginTop: "20px",
              textTransform: "none",
              borderRadius: "8px",
              width: "100%",
              "&:hover": { backgroundColor: "#1d80e0" },
            }}
            onClick={() => addLink(setLinksMakingOfEditado)}
          >
            Nuevo Link
          </Button>

          <Button
            variant="contained"
            sx={{
              fontWeight: "bold",
              fontFamily: "poppins",
              paddingBlock: "4px",
              backgroundColor: "#ff6400",
              marginTop: "20px",
              textTransform: "none",
              borderRadius: "8px",
              width: "100%",
              "&:hover": { backgroundColor: "#bb4a03" },
            }}
            onClick={() => {HandleUpdateItem({
              route: "serviciosCotizaciones",
              id: s.id,
              field: "grabacionProyectoMakingOfEditado",
              value: linksMakingOfEditado
            })
            setModalMakingOfEditado(false)
          }}
          >
            Guardar
          </Button>
        </div>
      </Modal>

      {/* Plataformas */}
      <Modal
        activeModal={modalPlataformas}
        onClose={() => setModalPlataformas(false)}
        centered
        title="Link videos plataformas"
        className="max-w-3xl"
      >
        <div className="max-h-[75vh] overflow-y-auto">
          
          <div className="flex flex-row items-center gap-3">

            <div className="flex flex-col gap-2 w-1/2">

              {/* Youtube */}
              <div className="mb-4 mt-4">
                <label className="text-xs block text-gray-700 mb-2 font-bold" htmlFor="linkYoutube">
                  Links Youtube
                </label>

                <div className="flex flex-col">

                  <label className="text-xs block text-gray-700 mb-1">
                    Making Of
                  </label>
                  <div className="flex mb-2">
                    <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                      <FaYoutube />
                    </span>
                    <input
                      type="text"
                      placeholder="Making of"
                      value={videoYoutubeMakingOf}
                      onChange={(e) => setVideoYoutubeMakingOf(e.target.value)}
                      className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                    />
                  </div>
                  <label className="text-xs block text-gray-700 mb-1">
                    Testimonio
                  </label>
                  <div className="flex mb-2">
                    <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                      <FaYoutube />
                    </span>
                    <input
                      type="text"
                      placeholder="Testimonio"
                      value={videoYoutubeTestimonio}
                      onChange={(e) => setVideoYoutubeTestimonio(e.target.value)}
                      className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                    />
                  </div>
                  <label className="text-xs block text-gray-700 mb-1">
                    Proyecto
                  </label>
                  <div className="flex mb-2">
                    <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                      <FaYoutube />
                    </span>
                    <input
                      type="text"
                      placeholder="Proyecto"
                      value={videoYoutubeProyecto}
                      onChange={(e) => setVideoYoutubeProyecto(e.target.value)}
                      className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                    />
                  </div>

                </div>
          
              </div>

              {/* Facebook */}
              <div className="mb-4 mt-4">
                <label className="text-xs block text-gray-700 mb-2 font-bold" htmlFor="linkFacebook">
                  Links Facebook
                </label>

                <div className="flex flex-col">

                  <label className="text-xs block text-gray-700 mb-1">
                    Making Of
                  </label>
                  <div className="flex mb-2">
                    <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                      <FaFacebook />
                    </span>
                    <input
                      type="text"
                      placeholder="facebook.com"
                      value={videoFacebookMakingOf}
                      onChange={(e) => setVideoFacebookMakingOf(e.target.value)}
                      className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                    />
                  </div>
                  
                  <label className="text-xs block text-gray-700 mb-1">
                    Testimonio
                  </label>
                  <div className="flex mb-2">
                    <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                      <FaFacebook />
                    </span>
                    <input
                      type="text"
                      placeholder="facebook.com"
                      value={videoFacebookTestimonio}
                      onChange={(e) => setVideoFacebookTestimonio(e.target.value)}
                      className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                    />
                  </div>

                  <label className="text-xs block text-gray-700 mb-1">
                    Proyecto
                  </label>
                  <div className="flex mb-2">
                    <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                      <FaFacebook />
                    </span>
                    <input
                      type="text"
                      placeholder="facebook.com"
                      value={videoFacebookProyecto}
                      onChange={(e) => setVideoFacebookProyecto(e.target.value)}
                      className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                    />
                  </div>
                
                </div>
          
              </div>

            </div>

            <div className="flex flex-col gap-2 w-1/2">

              {/* Linkedin */}
              <div className="mb-4 mt-4">
                <label className="text-xs block text-gray-700 mb-2 font-bold" htmlFor="linkLinkedin">
                  Links Linkedin
                </label>
                
                <div className="flex flex-col">
                  <label className="text-xs block text-gray-700 mb-1">
                    Making Of
                  </label>
                  <div className="flex mb-2">
                    <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                      <FaLinkedin />
                    </span>
                    <input
                      type="text"
                      placeholder="linkedin.com"
                      value={videoLinkedinMakingOf}
                      onChange={(e) => setVideoLinkedingMakingOf(e.target.value)}
                      className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                    />
                  </div>

                  <label className="text-xs block text-gray-700 mb-1">
                    Testimonio
                  </label>
                  <div className="flex mb-2">
                    <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                      <FaLinkedin />
                    </span>
                    <input
                      type="text"
                      placeholder="linkedin.com"
                      value={videoLinkedinTestimonio}
                      onChange={(e) => setVideoLinkedinTestimonio(e.target.value)}
                      className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                    />
                  </div>

                  <label className="text-xs block text-gray-700 mb-1">
                    Proyecto
                  </label>
                  <div className="flex mb-2">
                    <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                      <FaLinkedin />
                    </span>
                    <input
                      type="text"
                      placeholder="linkedin.com"
                      value={videoLinkedinProyecto}
                      onChange={(e) => setVideoLinkedinProyecto(e.target.value)}
                      className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                    />
                  </div>
                </div>
              </div>

              {/* Tiktok */}
              <div className="mb-4 mt-4">
                <label className="text-xs block text-gray-700 mb-2 font-bold" htmlFor="linkTiktok">
                  Links Tiktok
                </label>
                <div className="flex flex-col">

                  <label className="text-xs block text-gray-700 mb-1">
                    Making Of
                  </label>
                  <div className="flex mb-2">
                    <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                      <FaTiktok />
                    </span>
                    <input
                      type="text"
                      placeholder="tiktok.com"
                      value={videoTikTokMakingOf}
                      onChange={(e) => setVideoTikTokMakingOf(e.target.value)}
                      className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                    />
                  </div>

                  <label className="text-xs block text-gray-700 mb-1">
                    Testimonio
                  </label>
                  <div className="flex mb-2">
                    <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                      <FaTiktok />
                    </span>
                    <input
                      type="text"
                      placeholder="tiktok.com"
                      value={videoTikTokTestimonio}
                      onChange={(e) => setVideoTikTokTestimonio(e.target.value)}
                      className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                    />
                  </div>

                  <label className="text-xs block text-gray-700 mb-1">
                    Proyecto
                  </label>
                  <div className="flex mb-2">
                    <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                      <FaTiktok />
                    </span>
                    <input
                      type="text"
                      placeholder="tiktok.com"
                      value={videoTikTokProyecto}
                      onChange={(e) => setVideoTikTokProyecto(e.target.value)}
                      className="text-xs rounded-l-none rounded-r-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                    />
                  </div>

                </div>
              </div>

            </div>

          </div>

          <Button
            variant="contained"
            sx={{
              fontWeight: "bold",
              fontFamily: "poppins",
              paddingBlock: "4px",
              backgroundColor: "#ff6400",
              transform: "all",
              marginTop: "20px",
              animationDuration: "1000",
              textTransform: "none",
              borderRadius: "8px",
              width: "100%",
              '&:hover': {
                backgroundColor: "#bb4a03",
              }
            }}
            onClick={() => handleSave()}
          >
            Guardar
          </Button>
        
        </div>
      </Modal>

      <td scope="row" className="px-2 py-2 max-w-[150px] border border-gray-300 truncate text-center hover:cursor-pointer hover:underline transition-all duration-100">
        <select
          value={s.productorResponsable?.id}
          onChange={(e) => HandleUpdateSelect("productorResponsable", e.target.value === "" ? null : e.target.value, s.id, "serviciosCotizaciones")}
          className="text-xs w-full text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
          disabled={user.area.toUpperCase() !== "ADMINISTRACION"}
        >
          <option value={""}>Seleccionar</option>
          {workers?.map((w) => (
            <option value={w.id}>{w.name}</option>
          ))}
        </select>
      </td>
      <td scope="row" className="px-2 py-2 max-w-[250px] border border-gray-300 truncate text-center">
        <select
          value={s.estadoAudiovisual}
          onChange={(e) => HandleUpdateSelect("estadoAudiovisual", e.target.value, s.id, "serviciosCotizaciones", setServices)}
          className={`${GetStatusColor(s.estadoAudiovisual, colorAudiovisual)} text-xs w-full text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent `}
        >
          <option value={"No definido"} className={GetStatusColor("No definido", colorAudiovisual)}>No definido</option>
          <option value={"Por comenzar"} className={GetStatusColor("Por comenzar", colorAudiovisual)}>Por comenzar</option>
          <option value={"En proceso"} className={GetStatusColor("En proceso", colorAudiovisual)}>En proceso</option>
          <option value={"Terminado con exito"} className={GetStatusColor("Terminado con exito", colorAudiovisual)}>Terminado con exito</option>
          <option value={"No finalizado"} className={GetStatusColor("No finalizado", colorAudiovisual)}>No finalizado</option>
        </select>
      </td>
      <td scope="row" className="sticky z-20 left-0 bg-white px-2 py-2 max-w-[250px] border border-gray-300 truncate text-center font-bold">
        <span className="text-xs truncate">
          {s.cotizacion?.cliente?.nombreComercial}
          {/* {s.id} */}
        </span>
      </td>
      <td scope="row" className="px-2 py-2 max-w-[200px] border border-gray-300 truncate text-center">
        <span className="text-xs">
          {s.servicio.name}
        </span>
      </td>
      <td scope="row" className="px-2 py-2 max-w-[100px] border border-gray-300 truncate text-center">
        <span className={`${GetStatusColor(s.planServicio.name, PlanBackgroundColor)} text-xs px-2 py-1`}>
          {s.planServicio?.name}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-2 py-2 border border-gray-300 truncate text-center">
        <span className="text-xs">
          {FormatDateToDDMMYY(s.fechaIngreso)}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-2 py-2 border border-gray-300 text-center">
        <span className="text-xs">
          {FormatDateToDDMMYY(s.fechaInicio)}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-1 py-1 border border-gray-300 text-center">
        <span className="text-xs">
          {FormatDateToDDMMYY(s.fechaInfoCompleta)}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-2 py-2 border border-gray-300 text-center">
        <span className="text-xs">
          {FormatDateToDDMMYY(s.fechaFin)}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-2 py-2 border border-gray-300 text-center">
        <span className="text-xs">
          {FormatDateToDDMMYY(s.fechaTermino)}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-2 py-2 border border-gray-300 text-center">
        <span className="text-xs">
          {FormatDateToDDMMYY(s.fechEntrega)}
        </span>
      </td>
      <td scope="row" className="max-w-[150px] px-2 py-2 border border-gray-300 text-center">
        <span className="text-xs">
          {s.cotizacion.cotizador.name}
        </span>
      </td>
      <td scope="row" className="max-w-[250px] px-2 py-2 border border-gray-300 text-center">
        <span className="text-xs truncate block">
          {s.responsable?.name} - {s.responsable?.puesto}
        </span>
      </td>
      <td scope="row" className="max-w-[250px] px-2 py-2 border border-gray-300 text-center">
        <span 
          className={`text-xs truncate block ${s.testimonioClienteVideo && "hover:cursor-pointer hover:underline transition-all duration-100"}`}
          onClick={() => { s.testimonioClienteVideo && CopyToClipBoard(s.testimonioClienteVideo) }}
        >
          {s.testimonioClienteVideo ? s.testimonioClienteVideo : "-"}
        </span>
      </td>
      <td scope="row" className="max-w-[250px] px-2 py-2 border border-gray-300 text-center">
        <button 
          className="flex items-center w-full justify-center"
          onClick={() => setModalProyectoBorrador(true)}
        >
          <div className="p-1.5 text-blue-500 hover:bg-blue-600 hover:bg-opacity-25 rounded-md bg-blue-700 bg-opacity-10">
            <FaEye className="text-xs"/>
          </div>
        </button>
      </td>
      <td scope="row" className="max-w-[250px] px-2 py-2 border border-gray-300 text-center">
        <button 
          className="flex items-center w-full justify-center"
          onClick={() => setModalMakingOf(true)}
        >
          <div className="p-1.5 text-blue-500 hover:bg-blue-600 hover:bg-opacity-25 rounded-md bg-blue-700 bg-opacity-10">
            <FaEye className="text-xs"/>
          </div>
        </button>
      </td>
      <td scope="row" className="max-w-[250px] px-2 py-2 border border-gray-300 text-center">
      <button 
          className="flex items-center w-full justify-center"
          onClick={() => setModalTestimonioEditado(true)}
        >
          <div className="p-1.5 text-blue-500 hover:bg-blue-600 hover:bg-opacity-25 rounded-md bg-blue-700 bg-opacity-10">
            <FaEye className="text-xs"/>
          </div>
        </button>
      </td>
      <td scope="row" className="max-w-[250px] px-2 py-2 border border-gray-300 text-center">
        <button 
          className="flex items-center w-full justify-center"
          onClick={() => setModalProyectoEditado(true)}
        >
          <div className="p-1.5 text-blue-500 hover:bg-blue-600 hover:bg-opacity-25 rounded-md bg-blue-700 bg-opacity-10">
            <FaEye className="text-xs"/>
          </div>
        </button>
      </td>
      <td scope="row" className="max-w-[250px] px-2 py-2 border border-gray-300 text-center">
        <button 
          className="flex items-center w-full justify-center"
          onClick={() => setModalMakingOfEditado(true)}
        >
          <div className="p-1.5 text-blue-500 hover:bg-blue-600 hover:bg-opacity-25 rounded-md bg-blue-700 bg-opacity-10">
            <FaEye className="text-xs"/>
          </div>
        </button>
      </td>
      <td scope="row" className="max-w-[120px] px-2 py-2 border border-gray-300 text-center">
        <button 
          className="flex items-center w-full justify-center"
          onClick={() => setModalPlataformas(true)}
        >
          <div className="p-1.5 text-blue-500 hover:bg-blue-600 hover:bg-opacity-25 rounded-md bg-blue-700 bg-opacity-10">
            <FaEye className="text-xs"/>
          </div>
        </button>
      </td>
    </tr>
  )
}

export default ItemRowVentasAudiovisuales